import { render, staticRenderFns } from "./PredictionChoiceTeam.vue?vue&type=template&id=97aaa294&"
import script from "./PredictionChoiceTeam.vue?vue&type=script&lang=js&"
export * from "./PredictionChoiceTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports